module.exports = __webpack_public_path__ + "assets/images/custom-cues@3x-fdad7dd13c9e2c4e3e679b412c6e4f6e.png";